(function () {
  var CLOSE_MS = 180;
  var layoutRoots = [];
  var layoutRaf = 0;

  function updatePanelAnchor(root) {
    var panel = root.querySelector('.header-wc-mega__panel');
    if (!panel) return;
    var header = root.closest('.header');
    var rr = root.getBoundingClientRect();
    var anchorLeft;

    if (header) {
      var hRect = header.getBoundingClientRect();
      var pl = parseFloat(window.getComputedStyle(header).paddingLeft) || 0;
      anchorLeft = hRect.left + pl;
    } else {
      var labelSpan = root.querySelector('.header-wc-mega__trigger > span:first-of-type');
      var trigger = root.querySelector('.header-wc-mega__trigger');
      var anchor = labelSpan || trigger || root;
      anchorLeft = anchor.getBoundingClientRect().left;
    }

    var rawOffset = Math.round(anchorLeft - rr.left);
    root.style.setProperty('--wc-panel-left', rawOffset + 'px');
    root.style.setProperty('--wc-panel-vp-left', Math.round(anchorLeft) + 'px');
  }

  function registerLayoutRoot(root) {
    if (layoutRoots.indexOf(root) !== -1) return;
    layoutRoots.push(root);
  }

  function scheduleLayoutAll() {
    if (layoutRaf) return;
    layoutRaf = requestAnimationFrame(function () {
      layoutRaf = 0;
      layoutRoots = layoutRoots.filter(function (r) {
        return r && r.isConnected;
      });
      layoutRoots.forEach(updatePanelAnchor);
    });
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('resize', scheduleLayoutAll);
    window.addEventListener('scroll', scheduleLayoutAll, { passive: true, capture: true });
  }

  function handleize(str) {
    if (!str || typeof str !== 'string') return '';
    var s = str.toLowerCase();
    try {
      s = s.normalize('NFD').replace(/\p{M}+/gu, '');
    } catch (e) {
      s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    s = s.replace(/&/g, 'and');
    s = s.replace(/[^a-z0-9]+/g, '-');
    return s.replace(/^-+|-+$/g, '');
  }

  function normalizeItem(raw) {
    if (raw == null) return { label: '', handle: '', hot: false };
    if (typeof raw === 'string') {
      var t = raw.trim();
      return { label: t, handle: handleize(t), hot: false };
    }
    if (typeof raw === 'object') {
      var label = (raw.name != null ? String(raw.name) : raw.title != null ? String(raw.title) : '').trim();
      var h = raw.handle != null ? String(raw.handle).trim() : handleize(label);
      return { label: label, handle: h, hot: false };
    }
    return { label: String(raw), handle: handleize(String(raw)), hot: false };
  }

  /** 10 elite national teams — handles = handleize(label). World Cup, Countries, Retro/Kids (nations). */
  var HOT_NATIONAL_GROUPS = new Set([
    'argentina',
    'belgium',
    'brazil',
    'england',
    'france',
    'germany',
    'italy',
    'netherlands',
    'portugal',
    'spain',
  ]);

  /**
   * 10 elite clubs — Leagues + Retro/Kids (clubs). Extra handles = same club, different label in JSON.
   */
  var HOT_CLUB = new Set([
    'arsenal',
    'arsenal-fc',
    'barcelona',
    'bayern-munchen',
    'chelsea-fc',
    'juventus',
    'juventus-fc',
    'liverpool',
    'liverpool-fc',
    'manchester-city',
    'manchester-united',
    'psg',
    'real-madrid',
  ]);

  /** Popular NBA teams — Basketball mega. */
  var HOT_BASKETBALL = new Set([
    'boston-celtics',
    'chicago-bulls',
    'dallas-mavericks',
    'denver-nuggets',
    'golden-state-warriors',
    'los-angeles-lakers',
    'miami-heat',
    'milwaukee-bucks',
    'new-york-knicks',
    'phoenix-suns',
  ]);

  function isHotForKind(kind, handle) {
    if (!handle || !kind) return false;
    if (kind === 'groups' || kind === 'countries') {
      return HOT_NATIONAL_GROUPS.has(handle);
    }
    if (kind === 'leagues' || kind === 'clubs') {
      return HOT_CLUB.has(handle);
    }
    if (kind === 'basketball') {
      return HOT_BASKETBALL.has(handle);
    }
    if (kind === 'retro' || kind === 'kids') {
      return HOT_NATIONAL_GROUPS.has(handle) || HOT_CLUB.has(handle);
    }
    return false;
  }

  function fillMegaItemLink(a, it, base) {
    a.href = it.handle ? base + '/' + it.handle : base;
    a.textContent = '';
    if (it.hot) {
      a.classList.add('header-wc-mega__link--hot');
    }
    a.appendChild(document.createTextNode(it.label));
    if (it.hot) {
      a.appendChild(document.createTextNode(' '));
      var mark = document.createElement('span');
      mark.className = 'header-wc-mega__hot-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = '🔥';
      a.appendChild(mark);
    }
  }

  function showHint(grid, message) {
    grid.textContent = '';
    var li = document.createElement('li');
    li.className = 'header-wc-mega__cell header-wc-mega__cell--hint';
    var t = document.createElement('p');
    t.className = 'header-wc-mega__group-title';
    t.textContent = 'Groups menu';
    var p = document.createElement('p');
    p.className = 'header-wc-mega__hint';
    p.textContent = message;
    li.appendChild(t);
    li.appendChild(p);
    grid.appendChild(li);
  }

  function hydrateWcGroups(root) {
    if (!root) return;
    /* Only build once: re-running clears the grid and removes <a> nodes mid-click so navigation fails. */
    if (root.getAttribute('data-wc-groups-hydrated') === '1') return;
    var script = root.querySelector('script[type="application/json"][data-wc-mega-json]');
    var grid = root.querySelector('.header-wc-mega__grid');
    if (!grid) return;
    if (!script) {
      showHint(grid, 'Missing JSON script (data-wc-mega-json). Check snippet output.');
      root.setAttribute('data-wc-groups-hydrated', '1');
      return;
    }

    var kind = (root.getAttribute('data-wc-mega-kind') || '').trim();
    if (!kind) {
      kind = (script.getAttribute('data-wc-mega-kind') || '').trim();
    }

    var base = (root.getAttribute('data-collections-url') || '/collections').replace(/\/$/, '');
    var data;
    try {
      data = JSON.parse(script.textContent.trim());
    } catch (err) {
      showHint(grid, 'Invalid JSON in data-wc-mega-json script.');
      root.setAttribute('data-wc-groups-hydrated', '1');
      return;
    }

    var groups = data && data.groups;
    if (!Array.isArray(groups) || groups.length === 0) {
      showHint(grid, 'JSON has no groups array.');
      root.setAttribute('data-wc-groups-hydrated', '1');
      return;
    }

    grid.textContent = '';
    var frag = document.createDocumentFragment();
    var isDrawer = root.getAttribute('data-wc-mega-drawer') === 'true';

    if (isDrawer) {
      groups.forEach(function (g) {
        var items = g && g.items;
        if (!Array.isArray(items)) items = [];

        var wrapLi = document.createElement('li');
        var details = document.createElement('details');
        details.className = 'menu-drawer__wc-group';

        var summary = document.createElement('summary');
        summary.className =
          'menu-drawer__wc-group-summary menu-drawer__menu-item list-menu__item link link--text focus-inset';
        var titleSpan = document.createElement('span');
        titleSpan.textContent = (g && g.title) || '';
        summary.appendChild(titleSpan);

        var list = document.createElement('ul');
        list.className = 'menu-drawer__wc-nested-list list-menu';
        list.setAttribute('role', 'list');

        items.forEach(function (raw) {
          var it = normalizeItem(raw);
          if (!it.label) return;
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.className = 'header-wc-mega__link menu-drawer__wc-leaf-link';
          var effectiveHot = isHotForKind(kind, it.handle);
          fillMegaItemLink(a, { label: it.label, handle: it.handle, hot: effectiveHot }, base);
          li.appendChild(a);
          list.appendChild(li);
        });

        details.appendChild(summary);
        details.appendChild(list);
        wrapLi.appendChild(details);
        frag.appendChild(wrapLi);
      });

      grid.appendChild(frag);
      root.setAttribute('data-wc-groups-hydrated', '1');
      return;
    }

    groups.forEach(function (g) {
      var items = g && g.items;
      if (!Array.isArray(items)) items = [];

      var cell = document.createElement('li');
      cell.className = 'header-wc-mega__cell';

      var titleEl = document.createElement('p');
      titleEl.className = 'header-wc-mega__group-title';
      titleEl.textContent = (g && g.title) || '';

      var list = document.createElement('ul');
      list.className = 'header-wc-mega__list';
      list.setAttribute('role', 'list');

      items.forEach(function (raw) {
        var it = normalizeItem(raw);
        if (!it.label) return;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'header-wc-mega__link';
        var effectiveHot = isHotForKind(kind, it.handle);
        fillMegaItemLink(a, { label: it.label, handle: it.handle, hot: effectiveHot }, base);
        li.appendChild(a);
        list.appendChild(li);
      });

      cell.appendChild(titleEl);
      cell.appendChild(list);
      frag.appendChild(cell);
    });

    grid.appendChild(frag);
    root.setAttribute('data-wc-groups-hydrated', '1');
  }

  function bindDrawer(root) {
    if (!root) return;
    if (root.getAttribute('data-wc-mega-js') === '1') return;
    root.setAttribute('data-wc-mega-js', '1');
    var details = root.closest('details.menu-drawer__wc-accordion');
    if (!details) return;
    details.addEventListener('toggle', function () {
      if (details.open) hydrateWcGroups(root);
    });
  }

  function bind(root) {
    if (!root) return;
    if (root.getAttribute('data-wc-mega-drawer') === 'true') {
      bindDrawer(root);
      return;
    }
    if (root.getAttribute('data-wc-mega-js') === '1') return;
    root.setAttribute('data-wc-mega-js', '1');
    var panel = root.querySelector('.header-wc-mega__panel');
    if (!panel) return;

    var closeTimer;

    function closeNow() {
      clearTimeout(closeTimer);
      root.classList.remove('header-wc-mega--open');
    }

    function open() {
      clearTimeout(closeTimer);
      hydrateWcGroups(root);
      registerLayoutRoot(root);
      updatePanelAnchor(root);
      root.classList.add('header-wc-mega--open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        root.classList.remove('header-wc-mega--open');
      }, CLOSE_MS);
    }

    panel.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || typeof t.closest !== 'function') return;
      var link = t.closest('a.header-wc-mega__link');
      if (!link || !panel.contains(link)) return;
      closeNow();
    });

    root.addEventListener('mouseenter', open);
    root.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', open);
    panel.addEventListener('mouseleave', scheduleClose);

    root.addEventListener('focusin', open);
    root.addEventListener('focusout', function (ev) {
      if (!root.contains(ev.relatedTarget)) {
        scheduleClose();
      }
    });
  }

  function scan(container) {
    var roots = container.querySelectorAll
      ? container.querySelectorAll('[data-header-wc-mega]')
      : document.querySelectorAll('[data-header-wc-mega]');
    roots.forEach(bind);
  }

  function boot() {
    scan(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var roots = e.target.querySelectorAll('[data-header-wc-mega]');
    for (var i = 0; i < roots.length; i++) {
      roots[i].removeAttribute('data-wc-groups-hydrated');
      roots[i].removeAttribute('data-wc-mega-js');
    }
    scan(e.target);
  });
})();
